import { useMutation } from "@tanstack/react-query";
import { api } from "../components/api";
import { useSnackbar } from "../components/AppComponents/SnackBarProvider";
import { MESSAGE, SEVERITY } from "../utils/messages";

export const useFamilyListMutation = () => {
    const { updateSnackbar } = useSnackbar();
    return useMutation({
        mutationFn: () => api.common.getFamilyList(),
        onError: (error) => {
            console.error("Error fetching family list:", error);
            updateSnackbar({
                severity: SEVERITY.error,
                message: error?.message || MESSAGE.FETCH_ERROR,
            });
        }
    });
}